"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Shadows = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.8818027 17.1131863,20.8557914 12.2653623,20.9961629 L12,21 L11.7346377,20.9961629 C6.88681368,20.8557914 3,16.8818027 3,12 C3,7.02943725 7.02943725,3 12,3 Z M12,19 L8.12716805,19.001761 C9.20659044,19.6000899 10.4389641,19.9560568 11.7508207,19.9961932 L12,20 L12,19 Z M12,15 L4.58190884,15.0009677 C5.0517373,16.1612024 5.78586407,17.1861426 6.70962441,18.0011235 L12,18 L12,15 Z M12,11 L4.06188768,11.0000487 C4.02104125,11.3276273 4,11.6613564 4,12 C4,12.6907281 4.08753869,13.3610104 4.25212715,14.0003581 L12,14 L12,11 Z M12,7 L5.75494251,6.99960899 C5.05751047,7.8695153 4.5380748,8.88827156 4.25186923,10.000644 L12,10 L12,7 Z M12,4 C9.97134063,4 8.11904415,4.75509929 6.70883829,5.99957012 L12,6 L12,4 Z" })));
};
Shadows.displayName = 'Shadows';
exports.default = Shadows;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Shadows.js.map